export default "__VITE_PUBLIC_ASSET__33ba9003__"